module.exports = __webpack_public_path__ + "img/appStore.36ae75fb.png";